import React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  heading: {
    color: "#272727",
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  label: {
    textTransform: "none",
    color: "#868686",
    fontSize: "16px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
}));

const questions = [
  "What went well?",
  "What could have been done differently?",
  "Overall Feedback, if any.",
];

export const ClientFeedbackOptions: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography gutterBottom variant="h2" className={classes.heading}>
          Client will be asked to answer:
        </Typography>
      </Grid>
      {questions.map((q) => (
        <Grid item xs={12} key={q}>
          <Typography gutterBottom variant="body1" className={classes.label}>
            • {q}{" "}
            <span style={{ color: "#DC0101", fontSize: "14px" }}>(required)</span>
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};
